class SwiperComponent extends HTMLElement {
	constructor() {
		super();
		this.swiperOptions = JSON.parse(this.getAttribute("data-swiper-options")) || {};
		this.swiperInitialized = false; // Prevent multiple initializations

		// this.hiddenClass = "invisible";
		this.section = this.closest("section");
		this.observer = null;
	}

	connectedCallback() {
		if (this.section && this.section.classList.contains("shopify-section")) {
			// this.section.classList.add(this.hiddenClass);

			// Intersection Observer to check visibility
			this.observer = new IntersectionObserver((entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.init(); // Initialize Swiper when visible
						observer.disconnect(); // Stop observing after initialization
					}
				});
			});

			this.observer.observe(this.section); // Observe the section
		}

		if (Shopify.designMode) {
			window.addEventListener("shopify:section:load", () => this.init());
			window.addEventListener("shopify:section:select", () => this.init());

			// fallback initialization after delay in design mode
			setTimeout(() => {
				if (!this.swiperInitialized) this.init();
			}, 100);
		} else {
			window.addEventListener("load", () => this.init());
		}
	}

	init() {
		if (this.swiperInitialized) return; // prevent multiple initializations
		this.swiperInitialized = true;

		const swiperOptions = this.swiperOptions;
		const option = {
			slideshowId: swiperOptions.swiperId || "",
			slideCount: swiperOptions.slideCount || 1,
			slidesPerView: swiperOptions.slidesPerView || "auto",
			speed: swiperOptions.speed || 0,
			slidesPerViewDesktop: swiperOptions.slidesPerViewDesktop || swiperOptions.slidesPerView || 4,
			slidesPerViewTablet:
				swiperOptions.slidesPerViewTablet || swiperOptions.slidesPerViewDesktop || swiperOptions.slidesPerView || 3,
			spaceBetween: swiperOptions.spaceBetweenMobile || 0,
			spaceBetweenDesktop: swiperOptions.spaceBetweenDesktop || swiperOptions.spaceBetween || 0,
			spaceBetweenTablet:
				swiperOptions.spaceBetweenTablet || swiperOptions.spaceBetweenDesktop || swiperOptions.spaceBetweenMobile || 0,
			enabled: swiperOptions.enabled ?? true,
			enabledDesktop: swiperOptions.enabledDesktop ?? swiperOptions.enabled ?? true,
			enabledTablet: swiperOptions.enabledTablet ?? swiperOptions.enabledDesktop ?? swiperOptions.enabled ?? true,
			allowTouchMove:
				swiperOptions.allowTouchMove ??
				(typeof swiperOptions.slidesPerView === "number" && swiperOptions.slideCount > swiperOptions.slidesPerView),
			allowTouchMoveTablet:
				swiperOptions.allowTouchMoveTablet ??
				(typeof swiperOptions.slidesPerViewTablet === "number"
					? swiperOptions.slideCount > swiperOptions.slidesPerViewTablet
						? true
						: false
					: true),
			mousewheel: swiperOptions.mousewheel || {
				enabled: true,
				forceToAxis: true,
			},
			allowTouchMoveDesktop:
				swiperOptions.allowTouchMoveDesktop ??
				(typeof swiperOptions.slidesPerViewDesktop === "number"
					? swiperOptions.slideCount > swiperOptions.slidesPerViewDesktop
						? true
						: false
					: true),
		};
		this.swiperOptions = {
			a11y: false,
			allowTouchMove: swiperOptions.allowTouchMove == true,
			loop: swiperOptions.loop || false,
			rewind: swiperOptions.rewind || false,
			disableOnInteraction: swiperOptions.disableOnInteraction == true,
			enabled: option.enabled,
			watchOverflow: true,
			speed: swiperOptions.speed || 500,
			observer: true,
			cache: true,
			freeMode: swiperOptions.freeMode ?? true,
			slidesOffsetAfter: swiperOptions.slidesOffsetAfterMobile || 0,
			slidesPerView: option.slidesPerView,
			spaceBetween: option.spaceBetween,
			mousewheel: swiperOptions.mousewheel || {
				enabled: true,
				forceToAxis: true,
			},
			resistanceRatio: 0,
			allowTouchMove: option.allowTouchMove ?? true,
			breakpoints: {
				750: {
					enabled: option.enabledTablet,
					allowTouchMove: option.allowTouchMoveTablet || true,
					slidesPerView: option.slidesPerViewTablet,
					spaceBetween: option.spaceBetweenTablet,
				},
				990: {
					slidesOffsetAfter: swiperOptions.slidesOffsetAfterDesktop || 0,
					enabled: option.enabledDesktop,
					allowTouchMove: option.allowTouchMoveDesktop || true,
					slidesPerView: option.slidesPerViewDesktop,
					spaceBetween: option.spaceBetweenDesktop,
				},
			},
		};

		if (swiperOptions.navigation) {
			this.swiperOptions.navigation = {
				...swiperOptions.navigation,
			};
		}

		if (swiperOptions.effect == "fade") {
			this.swiperOptions.effect = "fade";
			this.swiperOptions.fadeEffect = {
				crossFade: true,
			};
		}

		if (swiperOptions.pagination == "custom_bullet") {
			this.swiperOptions.pagination = {
				el: swiperOptions.paginationElement,
				clickable: true,
				renderBullet: function (i, className) {
					return `
              <button class="${className}">
                <span></span>
              </button>
            `;
				},
			};
		} else {
			this.swiperOptions.pagination = {
				el: `.swiper-pagination--${swiperOptions.swiperId}`,
				clickable: true,
			};
		}

		if (swiperOptions.autoplay) {
			this.swiperOptions.autoplay = {
				...swiperOptions.autoplay,
			};

			if (swiperOptions.autoplayProgress) {
				const progressCircle = this.querySelector(`.autoplay-progress--${swiperOptions.swiperId} svg`);
				const progressContent = this.querySelector(`.autoplay-progress--${swiperOptions.swiperId} span`);

				this.swiperOptions.on = {
					autoplayTimeLeft(s, time, progress) {
						progressCircle.style.setProperty("--progress", 1 - progress);
						progressContent.textContent = `${Math.ceil(time / 1000)}`;
					},
				};
			}
		}
		this.swiper = new Swiper(this, {
			...this.swiperOptions
		});
	}
}
customElements.define("swiper-component", SwiperComponent);